export const MESSAGE_NOTIFICATION_EXPIRATION_TIME = 15 * 1000;
export const CUSTOMER_NAME_FALLBACK = "User";
export const CHAT_CHARACTER_LIMIT = 3000;
